import { useContext, createContext, useState, useEffect } from "react";
import { KeyContext } from "./key-context";
import { QualityContext } from "./quality-context";
import { BassContext } from "./bass-context";
import { lookupChord } from "../utils/chord-lookup";

export const ChordContext = createContext();

export const ChordProvider = ({ children }) => {
  const { keyValue } = useContext(KeyContext);
  const { qualityValue } = useContext(QualityContext);
  const { bassValue } = useContext(BassContext);

  const [chordData, setChordData] = useState(null);
  const [chordNotFound, setChordNotFound] = useState(false);

  useEffect(() => {
    const displayQuality = qualityValue === "Quality" ? "Maj" : qualityValue;
    const displayBass = bassValue === "Bass" ? "No Bass" : bassValue;

    const data = lookupChord(keyValue, displayQuality, displayBass);
    setChordData(data);
    setChordNotFound(data === null);
  }, [keyValue, qualityValue, bassValue]);

  return (
    <ChordContext.Provider value={{ chordData, chordNotFound }}>
      {children}
    </ChordContext.Provider>
  );
};
